import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function Legal() {
  const [legalText, setLegalText] = useState('');

  useEffect(() => {
    fetch('/01_legal.txt')
      .then((response) => response.text())
      .then((text) => setLegalText(text))
      .catch((error) => console.error('Error loading legal text:', error));
  }, []);

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        {legalText ? (
          <div style={styles.markdown}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {legalText}
            </ReactMarkdown>
          </div>
        ) : (
          <p>Loading…</p>
        )}
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    height: '100vh',
    background: 'linear-gradient(135deg, #e6fffa, #ffffff)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Segoe UI', sans-serif",
    paddingBottom: '4rem', // room for footer
  },
  card: {
    background: 'white',
    padding: '3rem',
    borderRadius: '16px',
    boxShadow: '0 12px 28px rgba(0,0,0,0.1)',
    textAlign: 'left',
    maxWidth: '700px',
    width: '100%',
    overflowY: 'auto',
    maxHeight: '80vh',
  },
  title: {
    fontSize: '2.5rem',
    color: '#234e52',
    marginBottom: '1.5rem',
    textAlign: 'center',
  },
  textBlock: {
    fontSize: '1rem',
    color: '#4a5568',
    whiteSpace: 'pre-wrap', // keeps line breaks from the .txt
    lineHeight: '1.6',
  },
};

export default Legal;
